// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 319) return "static/css/319.9714ed22.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}